import { authClient, API } from "../index";

// Get all userTypes
export const getUserTypes = (asociado = null) => {
  let url = `${API}/userType?getDisabled=true`;
  if (asociado !== null) {
    url += `&asociado=${asociado}`;
  }
  return authClient().get(url);
};

// Get userType by id
export const getUserTypeById = (id) => {
  return authClient().get(`${API}/userType/${id}`);
};

// Delete userType
export const deleteUserType = (id) => {
  return authClient().delete(`${API}/userType/${id}`);
};

// Create userType
export const postUserType = async (userType) => {
  return authClient().post(`${API}/userType`, userType);
};

// Update userType
export const updateUserType = async (id, userType) => {
  return authClient().put(`${API}/userType/${id}`, userType);
};

// Change status userType
export const changeStatusUserType = async (id, active) => {
  return authClient().put(`${API}/userType/change-status/${id}`, { active });
};
